import { render, staticRenderFns } from "./dashboard-ix.vue?vue&type=template&id=629b813a"
import script from "./dashboard-ix.vue?vue&type=script&lang=js"
export * from "./dashboard-ix.vue?vue&type=script&lang=js"
import style0 from "../../assets/site.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports